/*============================================================================
  Collection infinite scroll
  - Loads the next page of products when the user nears the bottom of the grid
  - Uses the Section Rendering API so the current filters and sort are kept
  - Falls back to the regular pagination if JS features are missing or a request fails
==============================================================================*/
(function() {
  var selectors = {
    container: '[data-infinite-scroll]',
    grid: '.collection-grid__wrapper .grid--uniform',
    loader: '[data-infinite-scroll-loader]',
    colorSwatch: '.color-swatch--with-image'
  };

  var classes = {
    active: 'collection-infinite--active',
    loading: 'loading'
  };

  var observer = null;
  var isLoading = false;

  function init() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    isLoading = false;

    var container = document.querySelector(selectors.container);
    if (!container || !container.dataset.nextUrl) {
      return;
    }

    // Keep the regular pagination for browsers without the needed APIs
    if (!('IntersectionObserver' in window) || !window.fetch || !window.DOMParser) {
      return;
    }

    container.classList.add(classes.active);

    observer = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) {
        loadNextPage(container);
      }
    }, { rootMargin: '0px 0px 600px 0px' });

    observer.observe(container);
  }

  function loadNextPage(container) {
    var nextUrl = container.dataset.nextUrl;
    if (isLoading || !nextUrl) {
      return;
    }

    isLoading = true;
    var loader = container.querySelector(selectors.loader);
    if (loader) {
      loader.classList.add(classes.loading);
    }

    var url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('section_id', container.dataset.sectionId);

    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Infinite scroll request failed: ' + response.status);
        }
        return response.text();
      })
      .then(function(html) {
        // Filters or sorting replaced the grid while this request was running
        if (!document.body.contains(container)) {
          return;
        }

        var newDom = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = newDom.querySelector(selectors.grid);
        var grid = document.querySelector(selectors.grid);
        var addedItems = [];

        if (newGrid && grid) {
          Array.prototype.slice.call(newGrid.children).forEach(function(item) {
            var node = document.importNode(item, true);
            grid.appendChild(node);
            addedItems.push(node);
          });
        }

        var newContainer = newDom.querySelector(selectors.container);
        container.dataset.nextUrl = (newContainer && newContainer.dataset.nextUrl) || '';

        initItems(addedItems);
      })
      .catch(function(error) {
        console.error(error);
        // Show the regular pagination so the user can still browse
        if (observer) {
          observer.disconnect();
          observer = null;
        }
        container.classList.remove(classes.active);
      })
      .then(function() {
        isLoading = false;
        if (loader) {
          loader.classList.remove(classes.loading);
        }

        if (!observer) {
          return;
        }

        // All products loaded
        if (!container.dataset.nextUrl) {
          observer.disconnect();
          observer = null;
          container.hidden = true;
          return;
        }

        // Re-observe so a sentinel that is still in view triggers another load
        observer.unobserve(container);
        observer.observe(container);
      });
  }

  // Match the behaviour the theme gives products on initial page load
  function initItems(items) {
    if (!items.length) {
      return;
    }

    if (window.AOS) {
      AOS.refreshHard();
    }

    items.forEach(function(item) {
      initQuickShop(item);
      initColorSwatchHovering(item);
    });

    document.dispatchEvent(new CustomEvent('collection:infinite-scroll-loaded', {
      detail: { items: items }
    }));
  }

  function initQuickShop(item) {
    if (!window.theme || !theme.settings || !theme.settings.quickView || !item.classList.contains('grid-product')) {
      return;
    }

    function productMouseover() {
      // No quick view on mobile breakpoint
      if (theme.config.bpSmall) {
        return;
      }
      item.removeEventListener('mouseover', productMouseover);
      item.removeEventListener('focusin', productMouseover);

      if (!item.dataset.productId) {
        return;
      }

      theme.preloadProductModal(
        item.dataset.productHandle,
        item.dataset.productId,
        item.querySelector('.quick-product__btn')
      );
    }

    item.addEventListener('mouseover', productMouseover);
    item.addEventListener('focusin', productMouseover);
  }

  function initColorSwatchHovering(item) {
    item.querySelectorAll(selectors.colorSwatch).forEach(function(swatch) {
      var image = item.querySelector('.grid-product__color-image--' + swatch.dataset.variantId);
      if (!image) {
        return;
      }

      swatch.addEventListener('mouseenter', function() {
        image.style.backgroundImage = 'url(' + swatch.dataset.variantImage + ')';
        image.classList.add('is-active');
      });
      swatch.addEventListener('mouseleave', function() {
        image.classList.remove('is-active');
      });
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // Filters and price range re-render the grid via ajax
  document.addEventListener('collection:reloaded', init);
  // Theme editor
  document.addEventListener('shopify:section:load', init);
})();
